export type EntityFormModeType = 'view' | 'edit' | 'delete' | 'add';

export enum EntityFormModeEnum {
    View = 'view',
    Edit = 'edit',
    Delete = 'delete',
    Add = 'add'
}
